(function () {
  // --- Patch global fetch : intercepte tout appel /cart/add fait par n'importe quel
  // bouton (natif, sticky Vitals, etc.) et le remplace par la sélection active de la
  // section "Offre paliers + cadeaux", si présente sur la page. Ne bloque jamais rien,
  // ne touche à aucun click/submit -> aucun risque de conflit ou de boucle avec une app tierce.
  if (!window.__volumeOfferFetchPatched) {
    window.__volumeOfferFetchPatched = true;
    var originalFetch = window.fetch;

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartAdd = url.indexOf('/cart/add') !== -1;
      var isVolumeOfferCall = isCartAdd && !(init && init.__volumeOfferBypass);

      if (isVolumeOfferCall) {
        var items = window.__getVolumeOfferItems ? window.__getVolumeOfferItems() : null;
        if (items) {
          init = init || {};
          var headers = init.headers || {};
          init = Object.assign({}, init, {
            method: 'POST',
            body: JSON.stringify({ items: items }),
            headers: Object.assign({}, headers, { 'Content-Type': 'application/json' })
          });
        }
      }

      var result = originalFetch.call(this, input, init);

      // __getVolumeOfferItems ne renvoie plus les bonus (ils passent desormais par
      // /cart/update.js pour ne pas emettre d'AddToCart cote Facebook). On les
      // applique donc apres coup, pour les boutons tiers (sticky Vitals, etc.).
      if (isVolumeOfferCall) {
        result
          .then(function () {
            if (window.__applyVolumeOfferBonuses) window.__applyVolumeOfferBonuses();
          })
          .catch(function () {});
      }

      return result;
    };
  }

  // Formatage de prix standard Shopify, respecte shop.money_format (ex: "${{amount}}", "{{amount}} $")
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultOption(opt, def) { return typeof opt === 'undefined' ? def : opt; }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function initVolumeOffer(root) {
    if (root.dataset.volumeOfferInit) return;
    root.dataset.volumeOfferInit = 'true';

    var tiers = root.querySelectorAll('[data-volume-offer-tier]');
    var submitBtn = root.querySelector('[data-volume-offer-submit]');
    var submitText = root.querySelector('[data-volume-offer-submit-text]');
    var errorEl = root.querySelector('[data-volume-offer-error]');
    var defaultSubmitText = submitText ? submitText.textContent : 'Add to cart';
    var gifts = root.querySelectorAll('[data-gift]');
    var colorMapEl = root.querySelector('[data-color-variant-map]');
    var colorMap = colorMapEl ? JSON.parse(colorMapEl.textContent) : {};
    var giftCardVariantId = root.dataset.giftCardVariantId;
    var giftCardMinQty = parseInt(root.dataset.giftCardMinQty, 10) || 2;
    var guideVariantId = root.dataset.guideVariantId;
    var guideMinQty = parseInt(root.dataset.guideMinQty, 10) || 1;
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var priceSuffix = root.dataset.priceSuffix || '';
    var savingsTemplate = root.dataset.savingsTemplate || 'Save [percent]%';

    // Textes traduits, injectés par le Liquid via les réglages du bloc
    var loadingText = root.dataset.loadingText || 'Adding...';
    var errorMissingColor = root.dataset.errorMissingColor || 'Please select a color for each item.';
    var errorGeneric = root.dataset.errorGeneric || 'Something went wrong. Please try again.';

    // Ne renvoie QUE les vrais produits (colliers). Les bonus sont volontairement
    // exclus d'ici : Shopify n'emet product_added_to_cart (= AddToCart Facebook)
    // que sur /cart/add.js, donc tout bonus ajoute par cette voie gonflait l'ATC.
    function getSelectedItems() {
      var selectedTier = root.querySelector('.volume-offer__tier.is-selected');
      if (!selectedTier) return null;

      var selects = selectedTier.querySelectorAll('[data-color-select]');
      var items = [];
      var missing = false;

      selects.forEach(function (select) {
        var entry = colorMap[select.value];
        if (!entry) {
          missing = true;
          return;
        }
        items.push({ id: entry.id, quantity: 1 });
      });

      if (missing) return null;

      // Fusionne les entrees identiques (ex. palier 2 colliers, meme couleur) :
      // Shopify fusionne les lignes de toute facon, mais le pixel comptait 2 items
      // -> 2 AddToCart pour un seul geste client.
      var merged = {};
      items.forEach(function (item) {
        merged[item.id] = (merged[item.id] || 0) + item.quantity;
      });

      return Object.keys(merged).map(function (id) {
        return { id: id, quantity: merged[id] };
      });
    }

    // Bonus offerts : envoyes via /cart/update.js, JAMAIS /cart/add.js.
    // update.js met la ligne au panier sans emettre d'evenement AddToCart, et
    // est idempotent (si le bonus est deja la, il reste simplement a 1).
    function applyBonuses() {
      var qty = getSelectedQty();
      var updates = {};

      if (guideVariantId && qty >= guideMinQty) {
        updates[guideVariantId] = 1;
      }
      if (giftCardVariantId && qty >= giftCardMinQty) {
        updates[giftCardVariantId] = 1;
      }

      if (!Object.keys(updates).length) return Promise.resolve();

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
        __volumeOfferBypass: true,
        __cartGuardBypass: true
      }).catch(function () {
        // Le garde-fou de theme.liquid rattrapera au prochain check.
        // On ne bloque jamais le client sur un bonus.
      });
    }

    // Expose pour le patch fetch global défini plus haut
    window.__getVolumeOfferItems = getSelectedItems;
    window.__applyVolumeOfferBonuses = applyBonuses;

    function updateGifts(qty) {
      gifts.forEach(function (gift) {
        var min = parseInt(gift.dataset.giftMinQty, 10) || 1;
        gift.classList.toggle('is-active', qty >= min);
      });
    }

    function getSelectedQty() {
      var checked = root.querySelector('.volume-offer__radio:checked');
      return checked ? parseInt(checked.value, 10) : 1;
    }

    // Recalcule et affiche le prix d'un palier à partir des vraies variantes sélectionnées
    function updateTierPrice(tierEl) {
      var priceBlock = tierEl.querySelector('[data-tier-price]');
      if (!priceBlock) return;

      var discountPercent = parseFloat(priceBlock.dataset.discountPercent) || 0;
      var qty = parseInt(priceBlock.dataset.qty, 10) || 1;

      var selects = tierEl.querySelectorAll('[data-color-select]');
      var baseTotalCents = 0;
      var compareTotalCents = 0;
      var missing = false;

      selects.forEach(function (select) {
        var entry = colorMap[select.value];
        if (!entry) {
          missing = true;
          return;
        }
        baseTotalCents += entry.price;
        compareTotalCents += entry.comparePrice || entry.price;
      });

      if (missing) return;

      var discountCents = Math.round((baseTotalCents * discountPercent) / 100);
      var displayTotalCents = baseTotalCents - discountCents;

      var displayPerUnitCents = qty > 1 ? Math.round(displayTotalCents / qty) : displayTotalCents;
      var comparePerUnitCents = qty > 1 ? Math.round(compareTotalCents / qty) : compareTotalCents;

      var priceNowEl = priceBlock.querySelector('[data-price-now]');
      var priceCompareEl = priceBlock.querySelector('[data-price-compare]');

      if (priceNowEl) {
        var suffixHtml = qty > 1 && priceSuffix
          ? '<span class="volume-offer__price-suffix">' + priceSuffix + '</span>'
          : '';
        priceNowEl.innerHTML = formatMoney(displayPerUnitCents, moneyFormat) + suffixHtml;
      }

      if (priceCompareEl) {
        if (compareTotalCents > displayTotalCents) {
          priceCompareEl.hidden = false;
          priceCompareEl.innerHTML = formatMoney(comparePerUnitCents, moneyFormat);
        } else {
          priceCompareEl.hidden = true;
        }
      }

      // Économisez X% ou X $ -> calculé sur le vrai prix plein Shopify (compare_at_price), pas le prix de vente
      var savingsEl = tierEl.querySelector('[data-savings-text]');
      if (savingsEl) {
        if (compareTotalCents > displayTotalCents) {
          var savingsPercent = Math.round(((compareTotalCents - displayTotalCents) / compareTotalCents) * 100);
          // Montant : arrondi au dollar (114$ plutôt que 113.99$), en texte brut (le format de la boutique contient du HTML), sans les ,00
          var savingsAmount = formatMoney(Math.round((compareTotalCents - displayTotalCents) / 100) * 100, moneyFormat).replace(/<[^>]*>/g, '').replace(/[.,]00(?!\d)/, '');
          savingsEl.textContent = savingsTemplate.replace('[percent]', savingsPercent).replace('[amount]', savingsAmount);
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
    }

    function updateAllTierPrices() {
      tiers.forEach(function (tier) { updateTierPrice(tier); });
    }

    tiers.forEach(function (tier) {
      var radio = tier.querySelector('.volume-offer__radio');
      tier.addEventListener('click', function (e) {
        if (e.target.closest('[data-color-select]')) return;

        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tier.classList.add('is-selected');
        radio.checked = true;
        updateGifts(getSelectedQty());
      });

      // Recalcule le prix de CE palier quand une de ses couleurs change
      var colorSelects = tier.querySelectorAll('[data-color-select]');
      colorSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          updateTierPrice(tier);
        });
      });
    });

    updateGifts(getSelectedQty());
    updateAllTierPrices();

    function setLoading(isLoading) {
      submitBtn.disabled = isLoading;
      if (submitText) {
        submitText.textContent = isLoading ? loadingText : defaultSubmitText;
      }
    }

    function addOfferToCart() {
      var items = getSelectedItems();
      errorEl.hidden = true;

      if (!items) {
        errorEl.textContent = errorMissingColor;
        errorEl.hidden = false;
        return;
      }

      setLoading(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
        __volumeOfferBypass: true, // évite que le patch global ne se réécrive lui-même
        __cartGuardBypass: true // ce flux ajoute deja guide+carte-cadeau lui-meme, pas besoin que theme.liquid revérifie en double
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          // Les cadeaux sont ajoutes ici, apres le collier, via /cart/update.js
          // -> le panier est complet AVANT l'ouverture du drawer Vitals, et
          //    Facebook ne recoit qu'UN seul AddToCart (celui du collier).
          return applyBonuses();
        })
        .then(function () {
          setLoading(false);
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          // Garde le vrai clic : c'est ce que Vitals intercepte pour ouvrir SON
          // drawer, independamment du reglage "Type de panier" du theme.
          var cartTrigger = document.querySelector('#HeaderCartTrigger');
          if (cartTrigger) cartTrigger.click();
        })
        .catch(function (err) {
          errorEl.textContent = (err && err.message) || errorGeneric;
          errorEl.hidden = false;
          setLoading(false);
        });
    }

    submitBtn.addEventListener('click', addOfferToCart);

    // Expose pour le sticky : appel direct de la logique reelle (validation,
    // fetch, cadeaux, ouverture du panier) sans passer par une simulation de
    // clic sur submitBtn, qui s'est averee peu fiable (timing, etat disabled).
    window.__submitVolumeOffer = addOfferToCart;

    var formSelector = root.dataset.productFormSelector;
    var nativeForms = formSelector ? document.querySelectorAll(formSelector) : [];

    nativeForms.forEach(function (nativeForm) {
      nativeForm.style.display = 'none';
    });
  }

  document.querySelectorAll('[data-volume-offer]').forEach(initVolumeOffer);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-volume-offer]').forEach(initVolumeOffer);
  });
})();
